var _path, _path2, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteT(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3477 7.65234H22.9995",
    stroke: "#B51D1D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7824 8.61183L3.28087 8.61279C3.01976 8.61289 2.8892 8.61294 2.77983 8.62505C1.84881 8.72817 1.11484 9.46242 1.01207 10.3935C1 10.5029 1 10.5819 1 10.7399C1 11.4182 1 12.2883 1 13.3961M1 13.3961C1 16.0569 1 18.2033 1 19.7239C1 19.983 1 20.1126 1.01208 20.222C1.11484 21.1528 1.84972 21.8877 2.78053 21.9905C2.88993 22.0025 3.01996 22.0025 3.28 22.0025H16.8931C17.1531 22.0025 17.2832 22.0025 17.3926 21.9905C18.3234 21.8877 19.0583 21.1528 19.161 20.222C19.1731 20.1126 19.1731 19.9826 19.1731 19.7225V18.1766M1 13.3961L5.7824 13.3942",
    stroke: "#B51D1D",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.44531,
    y: 0.75,
    width: 21.4555,
    height: 13.8037,
    rx: 1.25,
    stroke: "#B51D1D",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.47363,
    y: 17.3672,
    width: 3.47353,
    height: 2.31569,
    rx: 1.15784,
    fill: "#B51D1D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteT);
export default __webpack_public_path__ + "static/media/deleteT.aaab979948938578004e218ed9f8c3bf.svg";
export { ForwardRef as ReactComponent };